import type { INotification } from "../../../../types/models/notification.models.types";
import type {
    SocialApplicationStatus,
  SocialCreatorType,
  SocialGender,
} from "../../../../types/models/social.models.types";
import { usePostHttp } from "../../http.hook";

interface IBody extends INotification {
  filters: {
    socials: {
      applicationStatus: SocialApplicationStatus[];
      creatorType: SocialCreatorType[];
      genderPreference: SocialGender[];
    };
  };
}

export function useSendBulkAppNotificationAdminHttp() {
  return usePostHttp<IBody, null>({
    path: "/admin/notifications/broadcast",
  });
}
